/** Match UPC's linear 3D distance attenuation, including speaker overrides. */
export function voiceGain(distance: number, audible: number, conversational: number): number {
  if (!Number.isFinite(distance) || distance < 0 || !Number.isFinite(audible) || audible <= 0) return 0;
  const inner = Number.isFinite(conversational) ? Math.max(0, Math.min(conversational, audible)) : 0;
  if (distance >= audible) return 0;
  if (distance <= inner) return 1;
  return 1 - (distance - inner) / (audible - inner);
}
